import logo from "./logo.svg";
import "./App.css";
import HomePage from "./pages/HomePage";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Shop from "./pages/Shop";
import CategoryPage from "./pages/CategoryPage";
import Header from "./components/Header";
import Footer from "./components/Footer";
import SubCategoryPage from "./pages/SubCategoryPage";
import Personal from "./priya/Personal";
import AccountPage from "./pages/AccountPage";
import Order from "./priya/Order";
import WishList from "./priya/WishList";
import Ticket from "./priya/Ticket";
import Profile from "./priya/Profile";
import Address from "./priya/Address";
import Payment from "./priya/Payment";
import Wish from "./priya/Wish";
import ProductDetail from "./priya/ProductDetail";
import CartPage from "./pages/CartPage";
import WishlistPage from "./pages/WishListPage";
import { useEffect } from "react";
import {useLocation} from 'react-router-dom'
import CheckoutPage from "./pages/CheckoutPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import AuthProvider from "./context/AuthProvider";
import Success from "./pages/Success";
import BuyNow from "./pages/BuyNow";
import { Toaster } from "react-hot-toast";
import TypePage from "./pages/TypePage";
import AboutUs from "./pages/AboutUs";
import { SiWhatsapp } from "react-icons/si";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
      <>
        <ScrollToTop/>
        <Header/>
        <a
          href="https://wa.me/+918248843915"
          target="_blank"
          rel="noopener noreferrer"
          className="fixed sm:bottom-5 bottom-20 right-5 bg-green-600 z-50 text-white rounded-full p-2"
        >
          <SiWhatsapp size={30} />
        </a>
        <Routes>
          <Route index path="/" element={<HomePage />} />
          <Route path="/shop" element={<Shop/>}/>
          <Route path="/products/:productId" element={<ProductDetail/>}/>
          <Route path="/cart" element={<CartPage/>}/>
          <Route path="/checkout" element={<CheckoutPage/>}/>
          <Route path="/buynow/:productId" element={<BuyNow/>}/>
          <Route path="/wishlist" element={<WishlistPage/>}/>
          <Route path="/account" element={<AccountPage/>}>
            <Route path="" element={<Order/>}/>
            <Route path="wishlist" element={<Wish/>}/>
            <Route path="tickets" element={<Ticket/>}/>
            <Route path="profile" element={<Profile/>}/>
            <Route path="address" element={<Address/>}/>
            <Route path="payment" element={<Payment/>}/>
          </Route>
          <Route path="/category/:category" element={<CategoryPage/>}/>
          <Route path="/category/:category/:subCategory" element={<SubCategoryPage/>}/>
          <Route path="/category/:category/:subCategory/:type" element={<TypePage/>}/>
          <Route path="/about us" element={<AboutUs/>}/>
          <Route path="/login" element={<LoginPage/>}/>
          <Route path="/signup" element={<SignupPage/>}/>
          <Route path="/success" element={<Success/>}/>
        </Routes>
        <Footer/>
      </>
      <Toaster
        position="top-right"
        reverseOrder={true}
      />
    </BrowserRouter>
      </AuthProvider>
    
  );
}

export default App;

const ScrollToTop = () => {
   const location = useLocation();
 
   useEffect(() => {
     // Scroll to top whenever the route changes
     window.scrollTo(0, 0);
   }, [location]);
 
   return null;
 };